import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { APP_NAME, useTenantDisplayName } from "@/features/branding";

import { getCardV2faqData } from "../helpers/get-faq-data";

export const CardFAQDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const clientName = useTenantDisplayName() ?? APP_NAME;
  const datasource = getCardV2faqData({
    cardClient: clientName,
    client: clientName,
  });
  const idx = parseInt(id ?? "", 10);
  const item = datasource[idx];
  const { t } = useTranslation();
  return (
    <div className="bg-white p-4 h-full">
      <h6 className="text-xl font-semibold mb-4">
        {typeof item.question === "string"
          ? t(item.question)
          : t(...item.question)}
      </h6>

      {item.answer && <p className="mb-2">{t(item.answer)}</p>}

      {item.children && item.children}
    </div>
  );
};
